export var Size;

(function (Size) {
  Size["Sm"] = "sm";
  Size["Md"] = "md";
})(Size || (Size = {}));